/**
 * Global config object that will be populated from config.json
 * This is used to store configuration before the Angular DI system is initialized
 */
export let globalConfig: Record<string, unknown> = {};

/**
 * Fetches configuration from assets/config.json and stores it in a global variable
 * This is used before Angular is bootstrapped
 */
export async function fetchConfigFromJson(): Promise<void> {
	try {
		const response = await fetch('/assets/config.json');
		if (!response.ok) {
			throw new Error(`Failed to load config: ${response.status} ${response.statusText}`);
		}

		const config = await response.json();

		// Store the config in a global variable that can be accessed by services
		globalConfig = { ...config };

		console.info('Loaded runtime configuration:', config);
		return;
	} catch (error) {
		console.error('Error loading configuration from assets/config.json', error);
		// Re-throw to allow caller to handle the error
		throw error;
	}
}
